// get data for leaving a room/meeting
// https://mccglc.atlassian.net/l/c/1GzZpjKG for DOCS

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
  async handleLeaveRoom({getters,dispatch}) {
    if(document.fullscreenElement) document.exitFullscreen()
    if(getters['guest/room/isGuestPage']) return dispatch('guest/room/returnToRoomLobby', [false])
    // get location type before leaving the room and data gets updated on leave room
    let currentLocationType = getters.getCurrentLocationType
    let res = await dispatch('api/nav/leaveRoom')
    await dispatch('leaveSpaceCallback', {currentLocationType, res})
    return
  },
  async handleLeaveRoomAndSpace({dispatch}, [shouldRouteToHome, kicked]) {
    if(document.fullscreenElement) document.exitFullscreen()
    let res

    if (!kicked) {
      // if we're kicked, this is already handled
      res = await dispatch('api/nav/leaveRoom')
      if (!res.success) {
        dispatch('popups/nav/errorLeavingRoom')
        return res
      }
    }

    dispatch('analytics/leaveRoom', kicked ? 'kicked' : 'organic')

    if (shouldRouteToHome) {
      res = await dispatch('routing/goToHome')
    } else {
      // we might not have made any requests if kicked and shouldRouteToHome is true
      res = {
        success: {}
      }
    }
    return res
  },
  async leaveSpaceCallback({dispatch,commit}, {currentLocationType, res}) {
    if(res.success) {
      await dispatch('analytics/leaveRoom', 'organic')
      let data = res.success
      await dispatch('updateLocation',[data])

      //go back to area if leaving from a space page
      if(currentLocationType === 'space') {
        commit('routing/BLOCK_GET_AREA_DATA', true)
        await dispatch('routing/goToCurrentArea')
        await dispatch('enterAreaCallback', res)
      }
    } else {
      dispatch('popups/nav/errorLeavingRoom')
    }
    return
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
